<template>
  <div v-if="!loader">
    <v-row class="justify-end">
      <v-btn
        @click="createDialog = true"
        x-large
        class="ma-6 pa-2 rounded-xl white--text"
        color="#007bff"
      >
        {{ $t("add new units") }}<v-icon class="ma-2">mdi-plus</v-icon>
      </v-btn>
    </v-row>
    <create
      @createData="create"
      @closePopup="createDialog = false"
      :dialog="createDialog"
      :loader="craeteLoader"
    />
    <edit
      @editData="edit"
      @closePopup="editDialog = false"
      :dialog="editDialog"
      :orginalData="editData"
      :loader="editLoader"
    />
    <delete-popup
      @deleteData="deleteItem($event)"
      @closePopup="deleteDialog = false"
      :dialog="deleteDialog"
      :loader="deleteLoader"
      :item="deleteData"
    />
    <v-row>
      <v-col
        v-for="(item, i) in Lessons"
        :key="i"
        lg="2"
        md="3"
        sm="6"
        cols="12"
      >
        <card
          @clicked="$emit('openUnit', $event)"
          :icon="'mdi-note-text'"
          :item="item"
          :editAble="editAble"
          :deleteAble="deleteAble"
        />
      </v-col>
    </v-row>
  </div>
  <pulse-loader
    v-else
    :loading="true"
    :color="$vuetify.theme.themes.light.primary"
    size="20px"
  />
</template>
<script>
import { Lesson } from "@/store/common/lesson";
import card from "../../schools/card.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import lesson from "../../../../store/common/lesson";
export default {
  props: ["id", "data"],
  components: {
    create,
    edit,
    card,
  },
  data() {
    return {
      Lesson,
      params_id: "station_id",
      createDialog: false,
      editDialog: false,
      editData: null,
      deleteDialog: false,
      deleteData: null,
    };
  },
  methods: {
    getData() {
      let params = {
        subject_id: this.id,
      };
      this.name.get(params);
    },
    //create
    async create(data) {
      let payload = {
        name: data.name,
        subject_id: this.id,
        term: data.term,
      };
      await this.name.post(payload);
      this.createDialog = false;
      this.getData();
    },

    //edit
    editAble(data) {
      this.editData = data;
      this.editDialog = true;
    },
    async edit(data) {
      await this.name.edit(data.data, data.id);
      this.editDialog = false;
      this.getData();
    },

    //delete
    deleteAble(data) {
      this.deleteData = data;
      this.deleteDialog = true;
    },
    async deleteItem(id) {
      await this.name.deleteItem(id);
      this.deleteDialog = false;
      this.getData();
    },
  },
  computed: {
    name() {
      return Lesson;
    },
    Lessons() {
      return this.name.tableData.data;
    },
    loader() {
      return this.name.getState.loading;
    },
    craeteLoader() {
      return this.name.postState.loading;
    },
    editLoader() {
      return this.name.editState.loading;
    },
    deleteLoader() {
      return this.name.deleteState.loading;
    },
  },
  created() {
    this.getData();
  },
};
</script>
